document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-bn-calculator]').forEach((calculator) => {
    const length = calculator.querySelector('[data-bn-length]');
    const width = calculator.querySelector('[data-bn-width]');
    const waste = calculator.querySelector('[data-bn-waste]');
    const update = () => {
      const selected = calculator.querySelector('input[type="radio"]:checked');
      const area = Math.max(0, Number(length.value) || 0) * Math.max(0, Number(width.value) || 0);
      const tiles = Math.ceil((area / Number(selected.value)) * (1 + Number(waste.value) / 100));
      calculator.querySelector('[data-bn-area]').textContent = Math.round(area).toLocaleString();
      calculator.querySelector('[data-bn-tiles]').textContent = tiles.toLocaleString();
      calculator.querySelector('[data-bn-dimension]').textContent = selected.dataset.label;
      calculator.querySelector('[data-bn-waste-value]').textContent = `${waste.value}%`;
      calculator.querySelectorAll('fieldset label').forEach((label) => label.classList.toggle('is-selected', label.contains(selected)));
    };
    calculator.querySelectorAll('input').forEach((input) => input.addEventListener('input', update));
    update();
  });

  document.querySelectorAll('[data-bn-compare]').forEach((compare) => {
    const range = compare.querySelector('[data-bn-compare-range]');
    const update = () => compare.style.setProperty('--bn-compare-position', `${range.value}%`);
    range.addEventListener('input', update);
    update();
  });
});
